import { faArrowPointer } from '@fortawesome/pro-solid-svg-icons';
import { JSONContent } from '@tiptap/core';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentEditor } from 'components/organisms/document-editor/document-editor';
import { fragmentJSONToEditorContent } from 'components/organisms/document-editor/utils/node-utils';
import { Section } from '../section-ui';
import { SectionTitle } from '../section-ui/title';

interface Props {
  content: JSONContent[];
}
export const RequestedForContentSection: FC<Props> = ({ content }) => {
  const editorContent = useMemo(
    () => fragmentJSONToEditorContent(content),
    [content],
  );

  return (
    <Section
      title={
        <SectionTitle
          title={
            <FormattedMessage id="ask_ai_command_processor.request.section.selected_text.title" />
          }
          icon={<SectionTitle.Icon icon={faArrowPointer} />}
        />
      }
      contentBackgroundColor={'var(--browser-selection-background)'}
      content={<DocumentEditor value={editorContent} readonly />}
    />
  );
};
